export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
